module.exports = __webpack_public_path__ + "img/FC2-alt.c9defbf2.svg";